var _linearGradient, _linearGradient2, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgPillShape = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 1000 132",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    gradientUnits: "userSpaceOnUse",
    x1: 500,
    x2: 467.5,
    y1: 0.000015,
    y2: 115.5
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff",
    stopOpacity: 0.08
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    gradientUnits: "userSpaceOnUse",
    x1: 1015.5,
    x2: 986.928,
    y1: -28.6415,
    y2: 94.0733
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0546446,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipRule: "evenodd",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m934 1.99991h-932.00009v128.00009h932.00009c35.346 0 64-28.654 64-64 0-35.3463-28.654-64.00009-64-64.00009zm-934-1.99991v132h934c36.451 0 66-29.549 66-66 0-36.4508-29.549-66-66-66z",
    fill: "url(#a)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m934 1.99991h-932.00009v128.00009h932.00009c35.346 0 64-28.654 64-64 0-35.3463-28.654-64.00009-64-64.00009zm-934-1.99991v132h934c36.451 0 66-29.549 66-66 0-36.4508-29.549-66-66-66z",
    fill: "url(#b)",
    fillOpacity: 0.4
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgPillShape);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/pill-shape.452fad7af29344a772530d6093e9ffb9.svg";